<template>
  <div class="form-group">
    <label class="form-label" :for="inputId">{{label}}</label>
    <div class="input-group">
      <input
          type="url"
          :value="urlValue"
          :id="inputId"
          :placeholder="placeholderText"
          @input="$emit('input', $event.target.value)"
          class="form-control"
          :disabled="isUploading"
      />

      <button
          @click.prevent.stop="selectFile"
          class="btn btn-sm"
          style="width: 70px;"
          :class="{'loading': isUploading}"
          :disabled="isUploading"
      >
        Upload
      </button>
    </div>

    <input @change.prevent.stop="uploadSelectedFile" type="file" accept="image/*" ref="upload" class="d-none"/>
  </div>
</template>

<script>

  import {globalImageUploader} from '@/utils/api';

  export default {
    name: 'FormInputFileUpload',

    props: {
      value: String,
      label: String,
      placeholder: String,
      id: String,
      disabled: Boolean,
    },
    data: function() {
      return {
        urlValue: this.value,
        isUploading: false,
      };
    },
    computed: {
      inputId: function() {
        return `donation-flow-editor-${this.id || this.label.toLowerCase()}`;
      },
      placeholderText: function() {
        return this.placeholder || this.label;
      },
    },
    methods: {
      selectFile() {
        this.$refs.upload.click();
      },
      uploadSelectedFile() {
        let file = this.$refs.upload.files[0];

        if (file) {
          this.isUploading = true;
          globalImageUploader(file).then(image => {
            this.urlValue = image;
            this.isUploading = false;

            this.$emit('input', this.urlValue);
          }).catch(err => {
            alert(err);
            this.isUploading = false;
          });
        }
      },
    },
  };

</script>
<style lang="scss" scoped>
  .d-none {
    display: none;
  }
</style>
